import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import { searchBarSx } from '../styles';

interface ScheduledReportsSearchProps {
  search: string;
  onSearchChange: (value: string) => void;
}

function ScheduledReportsSearch({ search, onSearchChange }: Readonly<ScheduledReportsSearchProps>) {
  const { t: scheduledReportsT } = useTranslation('translation', {
    keyPrefix: 'admin.scheduledReports',
  });

  return (
    <TextField
      placeholder={scheduledReportsT('searchPlaceholder')}
      variant='outlined'
      size='small'
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      sx={searchBarSx}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: search && (
          <InputAdornment position='end'>
            <IconButton aria-label='clear search' onClick={() => onSearchChange('')} edge='end' size='small'>
              <CancelIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
      data-testid='scheduled-reports-search'
    />
  );
}

export default ScheduledReportsSearch;
